<template>
  <div class="component-wrapper d-flex flex-column align-center mt-2">
    <PageLoader v-if="pageLoader" />
    <AreaPreview
      v-else
      v-for="(area, i) in areas"
      :key="area.name + i"
      :area="area"
      :class="i == areas.length - 1 ? 'mb-12' : ''"
    />
  </div>
</template>

<script>
import AreaPreview from "@/components/AreaPreview.vue";
import PageLoader from "@/components/PageLoader.vue";

import { mapState, mapActions } from "vuex";
export default {
  components: {
    AreaPreview,
    PageLoader,
  },

  async created() {
    try {
      await this.getAreas();
      this.pageLoader = false;
    } catch (e) {
      this.pageLoader = false;
    }
  },

  data() {
    return {
      pageLoader: true,
    };
  },

  computed: {
    ...mapState({
      areas: (state) => state.areas.areas,
    }),
  },

  methods: {
    ...mapActions(["getAreas"]),
  },
};
</script>

<style scoped lang="scss"></style>
